import React from 'react';

const MatchmakingResultCardSkeleton: React.FC = () => {
  return (
    <article className="rounded-3xl border border-[#E5E7EB] bg-white shadow-[0_24px_80px_rgba(15,23,42,0.06)] animate-pulse">
      <div className="px-8 pt-8 pb-6">
        <div className="flex flex-wrap items-start justify-between gap-6">
          <div className="flex flex-1 items-start gap-4 min-w-[16rem]">
            {/* Circular icon skeleton */}
            <div className="h-14 w-14 rounded-full bg-gray-200 shrink-0 border-4 border-gray-100"></div>
            
            <div className="flex-1 space-y-4">
              <div className="space-y-3">
                <div className="flex flex-wrap items-center gap-3">
                  {/* Company name skeleton */}
                  <div className="h-7 w-64 bg-gray-200 rounded"></div>
                  {/* Badge skeleton */}
                  <div className="h-6 w-20 bg-gray-200 rounded-full"></div>
                </div>
                
                {/* AI Reasoning section skeleton */}
                <div className="space-y-1.5 max-w-4xl">
                  {/* AI Reasoning label skeleton */}
                  <div className="h-3 w-24 bg-gray-200 rounded"></div>
                  {/* Description text skeleton */}
                  <div className="space-y-2">
                    <div className="h-4 w-full bg-gray-200 rounded"></div>
                    <div className="h-4 w-full bg-gray-200 rounded"></div>
                    <div className="h-4 w-3/4 bg-gray-200 rounded"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          {/* Right side - Rating and Service Area skeleton */}
          <div className="flex flex-col items-end justify-center gap-3 mt-2">
            {/* Rating skeleton */}
            <div className="flex items-center gap-2">
              <div className="h-8 w-8 rounded-full bg-gray-200"></div>
              <div className="h-5 w-8 bg-gray-200 rounded"></div>
            </div>
            
            {/* Service Area skeleton */}
            <div className="flex items-start gap-2 text-right">
              <div className="h-4 w-4 mt-1 bg-gray-200 rounded"></div>
              <div className="flex flex-col leading-tight gap-1">
                <div className="h-3 w-24 bg-gray-200 rounded"></div>
                <div className="h-4 w-48 bg-gray-200 rounded"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Divider */}
      <div className="h-px w-full bg-[#f9fafc] border-t border-[#dbdbdb]"/>
      
      {/* Footer skeleton */}
      <div className="px-8 py-3 bg-[#f9fafc] space-y-6 rounded-b-3xl">
        <div className="flex flex-wrap items-center justify-between gap-4">
          {/* View More link skeleton */}
          <div className="h-5 w-24 bg-gray-200 rounded"></div>
          
          {/* Action buttons skeleton */}
          <div className="flex items-center gap-2">
            {[1, 2, 3, 4, 5].map((i) => (
              <div key={i} className="h-9 w-9 rounded-full bg-gray-200 border border-gray-200"></div>
            ))}
          </div>
        </div>
      </div>
    </article>
  );
};

export default MatchmakingResultCardSkeleton;

